import api from "@utils/api";

export const getcars = (idOrg, page, per_page) =>
  api.get(`/car/organizacion/${idOrg}?page=${page}&per_page=${per_page}`);
export const getCarById = (id) => api.get(`/car/${id}`);
export const createCar = (car) => api.post("/car", car);
export const updateCar = (id, car) => api.put(`/car/${id}`, car);
export const deleteCar = (id) => api.delete(`/car/${id}`);

export const getExcelAllCarsS3 = async (organizacion_id) => {
  try {
    const response = await api.get(`/car/export/excel_s3?organizacion_id=${organizacion_id}`);
    return response.data;
  } catch (error) {
    throw new Error(`Error al obtener el archivo Excel desde S3: ${error.message}`);
  }
};

